export const flagTitle = "UOb";
export const unflagTitle = "VOb";
export default {flagTitle,unflagTitle};